import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, unref as _unref, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, renderList as _renderList, Fragment as _Fragment, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from './assets/bg.jpg'


const _withScopeId = n => (_pushScopeId("data-v-69714a7c"),n=n(),_popScopeId(),n)
const _hoisted_1 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "bg" }, [
  /*#__PURE__*/_createElementVNode("img", {
    src: _imports_0,
    alt: ""
  })
], -1))
const _hoisted_2 = { class: "page-default page-media" }
const _hoisted_3 = { class: "info" }
const _hoisted_4 = ["innerHTML"]
const _hoisted_5 = { class: "more" }
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "icon i-gengduo" }, null, -1))
const _hoisted_7 = { class: "cover" }
const _hoisted_8 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("svg", {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 24 24"
}, [
  /*#__PURE__*/_createElementVNode("path", { d: "M24,21.996c-2.305-2.826-4.56-5.594-6.83-8.379c-0.555,0.631-1.092,1.24-1.659,1.885c-0.065-0.088-0.111-0.161-0.164-0.225 c-0.768-0.889-1.539-1.776-2.41-2.662V7.322h3.09V5.193h-2.99V2.001h-1.993v3.193h-2.99v2.129h3.09v5.245 c-0.736,0.74-1.374,1.478-2.012,2.216c-0.209,0.242-0.421,0.482-0.639,0.731c-0.564-0.643-1.11-1.265-1.665-1.899 c-2.275,2.793-4.529,5.56-6.827,8.38c0.145,0,0.215,0,0.287,0c0.778,0,1.557-0.005,2.335,0.004c0.18,0.002,0.302-0.061,0.423-0.202 c1.064-1.248,2.135-2.491,3.204-3.736c0.143-0.165,0.286-0.329,0.441-0.509c0.33,0.384,0.632,0.751,0.952,1.099 c0.123,0.133,0.113,0.232,0.042,0.385c-0.402,0.86-0.793,1.726-1.188,2.59c-0.036,0.078-0.067,0.159-0.1,0.237 c0.013,0.006,0.026,0.013,0.039,0.02c1.863-2.172,3.726-4.344,5.608-6.539c1.853,2.159,3.689,4.301,5.526,6.441 c0.013-0.079-0.007-0.133-0.031-0.185c-0.351-0.742-0.701-1.484-1.052-2.223c-0.249-0.524-0.251-0.523,0.123-0.957 c0.246-0.287,0.493-0.574,0.758-0.881c0.061,0.08,0.096,0.129,0.134,0.173c1.168,1.361,2.337,2.72,3.501,4.086 c0.121,0.142,0.242,0.203,0.424,0.2c0.753-0.011,1.508-0.004,2.261-0.005C23.77,21.996,23.854,21.996,24,21.996z" })
], -1))
const _hoisted_9 = ["innerHTML"]
const _hoisted_10 = { class: "column" }
const _hoisted_11 = ["onClick"]
const _hoisted_12 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "icon i-gengduo" }, null, -1))

import gospel, { State } from '@/store/gospel/home';
import { computed } from 'vue';
import { useRouter } from 'vue-router';
import { useStore } from 'vuex';
import i18, { State as I18State } from '@/store/i18';

export default /*#__PURE__*/_defineComponent({
  setup(__props) {

const router = useRouter()
const store = useStore()
const gospelState = computed<State>(() => store.state[gospel.name])
const leftHtml = computed(() => gospelState.value.content['index-left'].content)
const rightHtml = computed(() => gospelState.value.content['index-right'].content)
const columnData = computed(() => gospelState.value.categorys)
const i18data = computed<I18State>(() => store.state[i18.name])
const lang = computed(() => i18data.value.texts[i18data.value.lang.list[i18data.value.lang.now]].gospel)

function goFirst() {
    router.push({
        name: 'gospel/first'
    })
}

function goCateogry(id: number) {
    router.push({
        name: 'gospel/categories',
        params: {
            id
        }
    })
}

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _hoisted_1,
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("a", {
        class: "gospel",
        onClick: goFirst
      }, [
        _createElementVNode("h2", null, _toDisplayString(_unref(lang).homeTitle), 1),
        _createElementVNode("section", null, [
          _createElementVNode("div", _hoisted_3, [
            _createElementVNode("div", {
              class: "html",
              innerHTML: _unref(leftHtml)
            }, null, 8, _hoisted_4),
            _createElementVNode("div", _hoisted_5, [
              _createTextVNode(_toDisplayString(_unref(lang).more) + " ", 1),
              _hoisted_6
            ])
          ]),
          _createElementVNode("div", _hoisted_7, [
            _hoisted_8,
            _createElementVNode("div", { innerHTML: _unref(rightHtml) }, null, 8, _hoisted_9)
          ])
        ])
      ]),
      _createElementVNode("div", _hoisted_10, [
        _createElementVNode("h2", null, _toDisplayString(_unref(lang).homeCategory), 1),
        _createElementVNode("ul", null, [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(columnData), (item) => {
            return (_openBlock(), _createElementBlock("li", null, [
              _createElementVNode("a", {
                onClick: ($event: any) => (goCateogry(item.id))
              }, [
                _createElementVNode("div", null, [
                  _createElementVNode("h3", null, _toDisplayString(item.name), 1),
                  _createElementVNode("p", null, _toDisplayString(item.description), 1)
                ]),
                _createElementVNode("div", null, [
                  _createTextVNode(_toDisplayString(_unref(lang).more) + " ", 1),
                  _hoisted_12
                ])
              ], 8, _hoisted_11)
            ]))
          }), 256))
        ])
      ])
    ])
  ], 64))
}
}

})